import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
// Pages
import Home from './views/Home'

import Register from './views/auth/Register'
import Login from './views/auth/Login'
import Settings from './views/Settings'
import Dashboard from './views/user/Dashboard'

// Routes
const routes = [
  { name: 'home', path: '/', component: Home, meta: { auth: false } },
  { name: 'register', path: '/register', component: Register, meta: { auth: false } },
  { name: 'login', path: '/login', component: Login, meta: { auth: false } },
  { name: 'dashboard', path: '/dashboard', component: Dashboard, meta: { auth: true } },
  { name: 'settings', path: '/settings', component: Settings, meta: { auth: false } },

  { name: 'oferta', path: '/oferta', component: () => import('@/views/Oferta'), meta: { auth: undefined, noVerify: true } },
  { name: 'remind', path: '/remind', component: () => import('@/views/auth/Remind'), meta: { auth: undefined }, },
  { name: 'remind-new', path: '/remind/new', component: () => import('@/views/auth/RemindNewPassword'), meta: { auth: undefined }, },
  { name: 'verify-link', path: '/verify/:user/:hash', component: () => import('@/views/auth/Verify'), meta: { auth: undefined, noVerify: true }, },
  { name: 'verify', path: '/verify', component: () => import('@/views/auth/Verify'), meta: { auth: true, noVerify: true }, },

  { name: 'profile', path: '/profile', component: () => import('@/views/user/Profile'), meta: { auth: true, noVerify: true } },
  { name: 'support', path: '/support', component: () => import('@/views/user/Support'), meta: { auth: true, noVerify: true } },
  { name: 'subscription', path: '/subscription', component: () => import('@/views/user/Subscription'), meta: { auth: true } },
  { name: 'payments', path: '/subscription/payments', component: () => import('@/views/user/PaymentsHistory'), meta: { auth: true } },
  { name: 'payment-card', path: '/subscription/payment-card', component: () => import('@/views/user/PaymentCard'), meta: { auth: true } },
  { name: 'select-tariff', path: '/subscription/select', component: () => import('@/views/user/TariffSelect'), meta: { auth: true } },

  { name: 'panchanga', path: '/panchanga/:day?', component: () => import('@/views/Panchanga'), meta: { auth: true } },
  { name: 'dayprediction', path: '/dayprediction/:day?', component: () => import('@/views/DayPrediction'), meta: { auth: true } },
  { name: 'calendar', path: '/calendar/:month?', component: () => import('@/views/Calendar'), meta: { auth: true } },
]

Vue.use(Router)

const router = new Router({
  history: true,
  mode: 'history',
  routes,
})
router.beforeEach((to, from, next) => {
  var checker = (to, from, next) => {
    if (store.getters['auth/canSee'](to.meta)) 
      if (store.getters['auth/needVerification'] && ! to.meta.noVerify)
        next('/verify')
      else
        next()
    else
      if (store.getters['auth/loggedIn'])
        next('/dayprediction')
      else
        next('/')
  }

  if (store.getters['auth/loaded']) 
    checker(to, from, next)
  else
    store.dispatch('auth/init')
      .then(() => {
        if (! store.getters['auth/loaded'])
          store.dispatch('auth/fetch')
            .then(() => { checker(to, from, next) })
        else
          checker(to, from, next)
      })
})
export default router